/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import { Route, Switch } from 'react-router';

import NotFound from "./components/pages/NotFound/NotFound";
import BookContainer from "./components/pages/BookContainer/BookContainer";
import ProtectedRoute from "./components/pages/ProtectedRoute";

const Routes = () => (<Switch>
    <Route path="/print-book/:collId" render={(props) => <ProtectedRoute path="/print-book/:collId" component={BookContainer} {...props} />} />
    <Route path="*" component={NotFound}/>
</Switch>);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js